import axios from "axios";

export const createClassroom = async (id, authtoken, values) => {
    return await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/new`,
        { values },
        {
            headers: {
                authtoken,
            },
        }
    );
};

export const myClassrooms = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/${id}/my/classrooms`)
};

export const joinClassroom = async (id, authtoken, room_ID) => {
    return await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/${id}/join/classroom`,
        { room_ID },
        {
            headers: {
                authtoken,
            },
        }
    );
};

export const getMyClasses = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/${id}/my/classes`)
};

export const getClassroomDetails = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/${id}/my/classroom`)
}

export const getClassMessages = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/messages`)
}

export const sendMessage = async (id, authtoken, values) => {
    return await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/messages/new`,
        { values },
        {
            headers: {
                authtoken,
            },
        }
    );
}

export const getClassMeets = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/meets`)
};

export const newMeet = async (id, authtoken, values) => {
    return await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/meets/new`,
        { values },
        {
            headers: {
                authtoken,
            },
        }
    );
}

export const getClassAssignments = async (id) => {
    return await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/assignments`)
};

export const newAssignment = async (id, authtoken, values) => {
    return await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/${id}/class/assignments/new`,
        { values },
        {
            headers: {
                authtoken,
            },
        }
    );
}